import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ServicesSection = () => {
  const services = [
    {
      id: 1,
      icon: "Wrench",
      title: "Perbaikan AC",
      description: "Mengatasi semua masalah AC tidak dingin, bocor, berisik, dan konsumsi listrik tinggi dengan teknisi berpengalaman",
      features: [
        "Diagnosa menyeluruh",
        "Perbaikan komponen rusak",
        "Tes performa AC",
        "Garansi 1 bulan"
      ],
      price: "Rp 150.000",
      badge: "Paling Populer",
      badgeColor: "bg-accent"
    },
    {
      id: 2,
      icon: "Move",
      title: "Bongkar Pasang AC",
      description: "Layanan bongkar pasang AC untuk pindahan rumah, renovasi, atau instalasi AC baru dengan peralatan lengkap",
      features: [
        "Bongkar aman & rapi",
        "Instalasi profesional",
        "Tes kebocoran freon",
        "Garansi instalasi 6 bulan"
      ],
      price: "Rp 300.000",
      badge: "Termasuk Material",
      badgeColor: "bg-secondary"
    },
    {
      id: 3,
      icon: "Droplets",
      title: "Cuci AC",
      description: "Pembersihan menyeluruh indoor & outdoor unit untuk performa optimal dan udara lebih sehat untuk keluarga",
      features: [
        "Cuci indoor & outdoor",
        "Pembersihan filter",
        "Disinfektan anti bakteri",
        "Garansi bersih 1 bulan"
      ],
      price: "Rp 85.000",
      badge: "Hemat Listrik",
      badgeColor: "bg-primary"
    }
  ];

  const handleConsultation = (serviceTitle) => {
    const message = `Halo, saya tertarik dengan layanan ${serviceTitle}. Mohon info lebih lanjut dan jadwal kunjungan.`;
    window.open(`https://wa.me/6282226648077?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section id="layanan" className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="Settings" size={16} className="mr-2" />
            Layanan Profesional
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground mb-6">
            Solusi Lengkap Untuk Semua Kebutuhan AC
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto">
            Dari perbaikan darurat hingga perawatan rutin, kami menyediakan layanan AC terpercaya 
            dengan harga transparan dan garansi kepuasan.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services?.map((service) => (
            <div key={service?.id} className="relative bg-white rounded-2xl p-6 sm:p-8 shadow-card hover:shadow-xl transition-all duration-300 border border-border group flex flex-col">
              {/* Badge */}
              <div className={`absolute -top-3 left-6 ${service?.badgeColor} text-white px-4 py-1 rounded-full text-sm font-semibold`}>
                {service?.badge}
              </div>

              <div className="flex-grow">
                {/* Icon */}
                <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                  <Icon name={service?.icon} size={32} className="text-primary" />
                </div>

                {/* Content */}
                <h3 className="font-heading font-bold text-2xl text-foreground mb-4">
                  {service?.title}
                </h3>
                <p className="text-muted-foreground mb-6 leading-relaxed text-sm sm:text-base">
                  {service?.description}
                </p>

                {/* Features */}
                <ul className="space-y-3 mb-8">
                  {service?.features?.map((feature, index) => (
                    <li key={index} className="flex items-center">
                      <Icon name="CheckCircle" size={16} className="text-secondary mr-3 flex-shrink-0" />
                      <span className="text-sm text-foreground">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Pricing */}
              <div className="border-t border-border pt-6">
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 mb-4">
                  <div>
                    <span className="text-sm text-muted-foreground">Mulai dari</span>
                    <div className="text-2xl font-heading font-bold text-primary">{service?.price}</div>
                  </div>
                  <div className="w-full sm:w-auto text-left sm:text-right">
                    <div className="bg-secondary/10 text-secondary px-3 py-1 rounded-full text-sm font-semibold inline-block">
                      Konsultasi Gratis
                    </div>
                  </div>
                </div>

                <Button
                  variant="default"
                  fullWidth
                  onClick={() => handleConsultation(service?.title)}
                  iconName="MessageCircle"
                  iconPosition="left"
                  className="bg-primary hover:bg-primary/90 font-semibold"
                >
                  Konsultasi Sekarang
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="bg-gradient-to-r from-primary/5 to-secondary/5 rounded-2xl p-8 text-center">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="flex items-center justify-center">
              <Icon name="Shield" size={24} className="text-primary mr-3" />
              <div className="text-left">
                <div className="font-semibold text-foreground">Garansi Resmi</div>
                <div className="text-sm text-muted-foreground">Hingga 1 Bulan</div>
              </div>
            </div>
            <div className="flex items-center justify-center">
              <Icon name="Clock" size={24} className="text-secondary mr-3" />
              <div className="text-left">
                <div className="font-semibold text-foreground">Layanan Cepat</div>
                <div className="text-sm text-muted-foreground">Respon 30 menit</div>
              </div>
            </div>
            <div className="flex items-center justify-center">
              <Icon name="DollarSign" size={24} className="text-accent mr-3" />
              <div className="text-left">
                <div className="font-semibold text-foreground">Harga Transparan</div>
                <div className="text-sm text-muted-foreground">Tanpa biaya tersembunyi</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
